export const returnComponentByName = (node) => {
    let data;
    if (node === "水体透明度产品算法") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadSearchAndLocalFile", name: "基础数据:" },
                    { type: "UploadLocalFile", name: "瓦片第一波段:" }
                ]
            }
        ]
    }
    else if (node === "光合有效辐射吸收比率") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "输入瓦片波段:" },
                    { type: "UploadLocalFile", name: "植被类型:" }
                ]
            }
        ]
    }
    else if (node === "几何校正") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "输入图片:" },
                    { type: "UploadLocalFile", name: "输入文件:" }
                ]
            }
        ]
    }
    else if (node === "瓦片切分程序") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "0-2级卫星影像产品:" },
                    { type: "UploadLocalFile", name: "模板影像库路径:" }
                ]
            }
        ]
    }
    else if (node === "光学土壤含水量") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "输入瓦片波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "日", valueType: "int" },
                    { type: "UploadInput", name: "月", valueType: "int" },
                ]
            },
        ]
    }
    else if (node === "PM10产品算法") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "输入瓦片波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "季节", valueType: "int" },
                    { type: "UploadInput", name: "大气相对湿度", valueType: "int" },
                ]
            },
        ]
    }
    else if (node === "地表反射率产品" || node === "加" || node === "均值滤波" || node === "小于" || node === "大于" || node === "大气校正" ||
        node === "影像地图产品" || node === "海洋水色高精度快速反演" || node === "云量检测" || node === "地表温度专题产品" || node === "非" || node === "直方图增强" ||
        node === "亮温专题产品" || node === "方向滤波" || node === "中值滤波" || node === "人机交互程序" || node === "傅里叶变换" || node === "离水反射率" ||
        node === "辐亮度产品算法" || node === "坡度计算" || node === "统计滤波" || node === "坡向计算" || node === "植被指数计算" || node === "植被覆盖度计算") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            }
        ]
    }
    else if (node === "二值开运算" || node === "二值闭运算" || node === "灰度开运算" || node === "二值腐蚀" || node === "形态学滤波" || node === "灰度腐蚀" || node === "二值膨胀" || node === "灰度膨胀") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "掩模方阵宽度", valueType: "int" },
                ]
            },
        ]
    }
    else if (node === "云覆盖" || node === "阴影去除") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "分辨率", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "气溶胶反演专题产品" || node === "气溶胶专题产品") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "天顶角", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "面向对象分类" || node === "地表粗分类") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                    { type: "UploadLocalFile", name: "输入图片:" },
                ]
            },
        ]
    }
    else if (node === "内陆水体参量高精度反演") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "NDWI阈值", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "PCA变换") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "降维尺度", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "光学厚度") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                    { type: "UploadLocalFile", name: "TOAR输入瓦片:" },
                ]
            },
        ]
    }
    else if (node === "薄云去除") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "迭代次数", valueType: "int" },
                ]
            },
        ]
    }
    else if (node === "自定义模板滤波") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "自定义模板", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "HIS变换") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "正反变换选择", valueType: "int" },
                ]
            },
        ]
    }
    else if (node === "小波变换") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "分度解析", valueType: "int" },
                ]
            },
        ]
    }
    else if (node === "地物目标精细识别") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadPicture", name: "", valueType: "" },
                ]
            },
        ]
    }
    else if (node === "悬浮物浓度专题产品" || node === "叶绿素a浓度专题产品") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "计算参数A", valueType: "float" },
                    { type: "UploadInput", name: "计算参数B", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "叶面积指数专题") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "叶面积指数二次方系数", valueType: "float" },
                    { type: "UploadInput", name: "叶面积指数一次方系数", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "同态滤波") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "截止频率", valueType: "float" },
                    { type: "UploadInput", name: "高通增益", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "格式转换") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "输出文件数据格式", valueType: "string" },
                    { type: "UploadInput", name: "输出文件波段数", valueType: "int" },
                    { type: "UploadInput", name: "输出文件波段组合", valueType: "string" },
                    { type: "UploadInput", name: "后缀", valueType: "string" },
                ]
            },
        ]
    }
    else if (node === "叶面积指数反演") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "叶面积指数二次方系数", valueType: "float" },
                    { type: "UploadInput", name: "叶面积指数一次方系数", valueType: "float" },
                    { type: "UploadInput", name: "叶面积指数常系数", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "影像表观反射率") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "增益", valueType: "float" },
                    { type: "UploadInput", name: "偏差", valueType: "float" },
                    { type: "UploadInput", name: "日地距离", valueType: "float" },
                    { type: "UploadInput", name: "太阳平均辐射强度", valueType: "float" },
                    { type: "UploadInput", name: "太阳天顶角", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "投影变换") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "投影信息", valueType: "string" },
                    { type: "UploadInput", name: "重采样方式", valueType: "int" },
                    { type: "UploadInput", name: "输出文件基本信息", valueType: "string" },
                    { type: "UploadInput", name: "输出文件地理范围", valueType: "string" },
                ]
            },
        ]
    }
    else if (node === "除" || node === "乘" || node === "图像拼接" || node === "与" || node === "图像融合" || node === "或" || node === "减" || node === "异或") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
        ]
    }
    else if (node === "变化检测专题产品") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "瓦片第一波段:" },
                    { type: "UploadLocalFile", name: "瓦片第二波段:" },
                    { type: "UploadLocalFile", name: "瓦片第三波段:" },
                    { type: "UploadLocalFile", name: "瓦片第四波段:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "阈值", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星正射" || node === "3米L-SAR卫星正射校正" || node === "5米S-SAR卫星正射校正" || node === "高轨20米SAR卫星正射校正") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "DEM:" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星高程" || node === "3米L-SAR卫星高程" || node === "5米S-SAR卫星高程" || node === "高轨20米SAR卫星高程") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "气象数据:" },
                    { type: "UploadLocalFile", name: "DEM:" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星后向散射系数" || node === "3米L-SAR卫星后向散射系数" || node === "5米S-SAR卫星后向散射系数" || node === "高轨20米SAR卫星后向散射系数") {
        //
        data = [{}];
    }
    else if (node === "1米C-SAR卫星干涉测量相位大气延迟校正" || node === "3米L-SAR卫星干涉测量相位大气延迟校正" || node === "5米S-SAR卫星干涉测量相位大气延迟校正" || node === "高轨20米SAR卫星干涉测量相位大气延迟校正") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "辅助SAR数据:" },
                    { type: "UploadLocalFile", name: "气象数据1:" },
                    { type: "UploadLocalFile", name: "气象数据2:" },
                    { type: "UploadLocalFile", name: "DEM1:" },
                    { type: "UploadLocalFile", name: "DEM2:" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星干涉测量形变" || node === "3米L-SAR卫星干涉测量形变" || node === "5米S-SAR卫星干涉测量形变" || node === "高轨20米SAR卫星干涉测量形变") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "DEM:" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星土壤水分" || node === "3米L-SAR卫星土壤水分" || node === "5米S-SAR卫星土壤水分") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "Cover:" },
                    { type: "UploadLocalFile", name: "NDVI:" },
                    { type: "UploadLocalFile", name: "NDWI:" },
                    { type: "UploadLocalFile", name: "DEM1:" },
                    { type: "UploadLocalFile", name: "DEM2:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "e1", valueType: "float" },
                    { type: "UploadInput", name: "e2", valueType: "float" },
                    { type: "UploadInput", name: "c", valueType: "float" },
                    { type: "UploadInput", name: "d", valueType: "float" },
                    { type: "UploadInput", name: "λ", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "高轨20米SAR卫星土壤水分") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "Cover:" },
                    { type: "UploadLocalFile", name: "NDVI:" },
                    { type: "UploadLocalFile", name: "NDWI:" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星土壤盐碱度" || node === "3米L-SAR卫星土壤盐碱度" || node === "1米C-SAR卫星地表粗糙度" || node === "3米L-SAR卫星地表粗糙度") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "Cover:" },
                    { type: "UploadLocalFile", name: "NDVI:" },
                    { type: "UploadLocalFile", name: "MeasureData:" },
                ]
            },
        ]
    }
    else if (node === "1米C-SAR卫星植被物候" || node === "3米L-SAR卫星植被物候") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "MeasureData:" },
                ]
            },
            {
                type: "parameter", componentList: [
                    { type: "UploadInput", name: "α", valueType: "float" },
                    { type: "UploadInput", name: "ts", valueType: "float" },
                    { type: "UploadInput", name: "Iter", valueType: "float" },
                    { type: "UploadInput", name: "Kernel", valueType: "float" },
                    { type: "UploadInput", name: "Cost", valueType: "float" },
                ]
            },
        ]
    }
    else if (node === "3米L-SAR卫星植被高度") {
        data = [
            {
                type: "tile", componentList: [
                    { type: "UploadLocalFile", name: "辅SAR影像:" },
                ]
            },
        ]
    }
    else {
        //
        data = [{}];
    }
    return data;
}

export const returnRuntimeDescribe = (inputTestFileName, inputTestFilePath) => {
    let sendData = {
        "algDescribe": {
            "aEnvironment": [
                {
                    "bandwidth": "string",
                    "clusterNum": "string",
                    "cpu": "string",
                    "gpu": "string",
                    "isCluster": "string",
                    "memory": "string",
                    "networkCard": "string",
                    "operatingSystem": "string",
                    "storage": "string"
                }
            ],
            "aPamas": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "algoirthmID": "string",
            "algorithmAlias": "string",
            "algorithmClass": "string",
            "algorithmDesc": "string",
            "algorithmLevel": "string",
            "algorithmName": "string",
            "artificial": "string",
            "author": "string",
            "calPamas": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "chsName": "string",
            "dataTransModel": "string",
            "dllName": "string",
            "inputTestFileName": inputTestFileName,
            "inputTestFilePath": inputTestFilePath,
            "manPamas": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "outputTestFileName": "string",
            "outputTestFilePath": "string",
            "outputs": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "type": "string",
            "utilities": [
                {
                    "resolution": "string",
                    "satellite": "string",
                    "sensor": "string"
                }
            ],
            "version": "string"
        },
        "algName": "string",
        "rootPath": "string",
        "runtimeXMLPath": "string",
        "taskid": "string"
    }
    return sendData;
}

    export const runtimeDescribe = {
        "algDescribe": {
            "aEnvironment": [
                {
                    "bandwidth": "string",
                    "clusterNum": "string",
                    "cpu": "string",
                    "gpu": "string",
                    "isCluster": "string",
                    "memory": "string",
                    "networkCard": "string",
                    "operatingSystem": "string",
                    "storage": "string"
                }
            ],
            "aPamas": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "algoirthmID": "string",
            "algorithmAlias": "string",
            "algorithmClass": "string",
            "algorithmDesc": "string",
            "algorithmLevel": "string",
            "algorithmName": "string",
            "artificial": "string",
            "author": "string",
            "calPamas": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "chsName": "string",
            "dataTransModel": "string",
            "dllName": "string",
            "inputTestFileName": "string",
            "inputTestFilePath": "string",
            "manPamas": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "outputTestFileName": "string",
            "outputTestFilePath": "string",
            "outputs": [
                {
                    "dataType": "string",
                    "description": "string",
                    "maxValue": "string",
                    "minValue": "string",
                    "noDataValue": "string",
                    "optionValue": "string",
                    "paraChsName": "string",
                    "paraName": "string",
                    "paraSource": "string",
                    "paraType": "string",
                    "paraValue": "string"
                }
            ],
            "type": "string",
            "utilities": [
                {
                    "resolution": "string",
                    "satellite": "string",
                    "sensor": "string"
                }
            ],
            "version": "string"
        },
        "algName": "string",
        "rootPath": "string",
        "runtimeXMLPath": "string",
        "taskid": "string"
    }